import React from "react";
import "./radio-select-frame.scss";
import { RadioInput } from "../radio-input/radio-input";
import ExclusiveTag from "../exclusive_tag";

const RadioSelectFrame = props => {
  const { title, description, isSelected = false, onClick, tag } = props;

  let classes = "radio-select-frame";
  if (isSelected) {
    classes += " radio-select-frame__selected";
  }

  return (
    <div className={classes} onClick={onClick}>
      <div className="radio-select-frame__input">
        <RadioInput readOnly name={title} id={title} checked={isSelected} />
      </div>
      <div className="radio-select-frame__text">
        <div className="flex-row-container">
          <h3 className="bold no-margin m-bxxxs no-padding">{title}</h3>
          {tag && <ExclusiveTag className="m-lxxs">{tag}</ExclusiveTag>}
        </div>
        <div>{description}</div>
      </div>
    </div>
  );
};

export const RadioSelectFrameField = props => {
  const { options, value, onChange } = props;

  return (
    <>
      {options.map(option => {
        const { title, description, tag, optionValue } = option;

        return (
          <RadioSelectFrame
            isSelected={optionValue === value}
            key={title}
            title={title}
            description={description}
            tag={tag}
            onClick={() => {
              onChange(optionValue);
            }}
          />
        );
      })}
    </>
  );
};

export default RadioSelectFrame;
